import React, { useCallback, useState } from "react";

import { useIntl } from "react-intl";

import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";
import { Modal } from "@mapmycustomers/ui";

import RecipientSelector from "../EmailRecipientSelect";

import messages from "./messages";
import styles from "./TemplatePreviewAsModal.module.scss";

interface PreviewAsModalProps {
  onConfirm?: (id: EntitiesSupportedByEmailFeature["id"]) => void;
  onHide: () => void;
  recipients: EntitiesSupportedByEmailFeature[];
  selectedRecipientId?: EntitiesSupportedByEmailFeature["id"];
}

const TemplatePreviewAsModal = ({
  onConfirm,
  onHide,
  recipients,
  selectedRecipientId,
}: PreviewAsModalProps) => {
  const intl = useIntl();
  const [recipientId, setRecipientId] = useState<EntitiesSupportedByEmailFeature["id"] | undefined>(
    selectedRecipientId
  );

  const handleOk = useCallback(() => {
    if (recipientId) {
      onConfirm?.(recipientId);
      onHide();
    }
  }, [recipientId, onConfirm, onHide]);

  return (
    <Modal
      cancelText={intl.formatMessage(messages.cancel)}
      okButtonProps={{ disabled: !recipientId }}
      okText={intl.formatMessage(messages.okay)}
      onCancel={() => onHide()}
      onOk={handleOk}
      open
      title={intl.formatMessage(messages.previewAs)}
    >
      <RecipientSelector onChange={setRecipientId} recipients={recipients} value={recipientId} />
      <div className={styles.description}>
        {intl.formatMessage(messages.previewTemplateDescription)}
      </div>
    </Modal>
  );
};

export default TemplatePreviewAsModal;
